import React from 'react';
import { BidAskLineChart } from '../../../../charts/d3/linechart/BidAskLineChart';
import { TimeAndSalesTable } from './timeAndSales/TimeAndSalesTable';

export const AuxPanelContents = ({ tradePlanId, selection }) => {
  if (selection === 'bidAsk')
    return <BidAskLineChart tradePlanId={tradePlanId} size={165} />;
  else return <TimeAndSalesTable tradePlanId={tradePlanId} />;
};
